<template>
    <div class="form-group" :class="{'has-error': errors.has(inputId)}">
        <label :for="inputId" v-html="deleteTags(label)"></label><label v-if="required" class="red"> *</label>
        <!--select :id="inputId" v-model="inputVal" :name="inputId" v-validate="validations"
                 :data-vv-as="deleteTags(label)" class="form-control">
            <option value="">{{t('Select...')}}</option>
            <option v-for="option in options" :value="option.key" :key="option.key">{{option.label}}</option>
        </select-->
        <div class="row no-gutters ml-5">
            <div class="col-12" v-if="isForced">
                {{ forcedLabel }}
                <small class="form-text text-muted">{{ t('Included with your registration') }}</small>
            </div>
            <div class="col-12" v-else-if="isEditable()">
                {{ inputVal === 'Other' ? `${t('Other')}: ${other_value}` : inputVal }}
            </div>
            <template v-else>
                <div class="col-12" v-for="(option, index) in options" :key="option.key">
                    <div class="radio-container mt-1 pl-0 mb-0">
                        <div class="custom-control custom-radio radio-margin my-1 ml-0 py-2 pl-0 pr-3" style="border: none;">
                            <input :id="`${inputId}_${index}`" v-model="inputVal" :name="`${inputId}_${index}`" :value="option.key" type="radio" class="custom-control-input">
                            <label :for="`${inputId}_${index}`" class="custom-control-label">{{ option.label }}</label>
                        </div>
                    </div><!-- .radio-container -->
                </div><!-- .col-12 -->
                <div class="col-12"><!-- Other -->
                    <input :id="`${inputId}_value`" v-model="inputVal" :name="`${inputId}_value`" v-validate="validations" type="hidden" :v-validate="required ? 'required' : 'none'" >
                </div><!-- .col-12 -->
                <div class="col-12" v-if="includeOther"><!-- Other -->
                    <div class="radio-container mt-1 pl-0 mb-0">
                        <div class="custom-control custom-radio custom-radio-other radio-margin my-1 ml-0 py-2 pl-0 pr-3" style="border: none;">
                            <input :id="`${inputId}_other`" v-model="inputVal" :name="`${inputId}_other`" value="Other" type="radio" class="custom-control-input">
                            <label :for="`${inputId}_other`" class="custom-control-label">{{ t('Other') }}</label>
                            <input 
                                :id="`${inputId}_other_value`" 
                                type="text" 
                                v-model="other_value"
                                v-if="inputVal === 'Other'" 
                                :v-validate="required ? 'required' : 'none'" 
                                class="form-control" 
                                :placeholder="t('Type other option')" 
                            />
                            <input type="text" disabled v-else class="form-control disabled" :placeholder="t('Type other option')" />
                        </div>
                    </div><!-- .radio-container -->
                </div><!-- .col-12 -->
            </template>
        </div><!-- .row -->
        <span class="md-error red" v-html="errors.first(inputId+'_value')"></span>
        <br>
        <span 
            class="md-error red" 
            v-if="inputVal && !includeOther && !isEditable() && !options.map(option => option.key).includes(inputVal)">
            {{ t('The selected value is not in the options:') }} {{inputVal}}
        </span>
    </div>
</template>

<script>
    export default {
        name: "checkout-form-select",
        props: ['value', 'label', 'options', 'required', 'inputValidations', 'uniqueId', 'includeOther', 'other_value', 'notEditable','level_access', 'forcedValue'],
        inject: ['$validator'],
        data() {
            return {
                inputVal: (this.forcedValue != null && this.forcedValue !== '') ? this.forcedValue : this.value,
                inputId: null
            }
        },
        computed: {
            _() {
                return _;
            },
            isForced() {
                return this.forcedValue != null && this.forcedValue !== '';
            },
            forcedLabel() {
                let selected = (this.options || []).find(option => option.key === this.inputVal);
                return (selected && selected.label) || this.inputVal;
            },
            validations() {
                let validations = {};

                validations.required = this.required;

                if (this.inputValidations) {
                    const dbValidations = JSON.parse(this.inputValidations);
                    validations = Object.assign(validations, dbValidations);
                }


                //validamos quee el valor que seleccionamos este en las opciones
                let allowedValues = this.options.map(option => option.key);
                if (this.includeOther) {
                    allowedValues.push('Other');
                }
                validations.included = allowedValues;
                return validations;
            }
        },
        watch: {
            value(val) {
                if (this.isForced) {
                    return;
                }
                this.inputVal = val;
            },
            inputVal(val) {
                this.$emit('input', val);
            },
            other_value: {
                handler (val, old) {
                    this.$emit('updateOtherValue', val);
                },
                deep: true,
            },
        },
        created() {
            if (!this.isForced) {
                this.value = '';
            }
            this.inputId = this.uniqueId || _.uniqueId();
        },
        methods:{
          deleteTags(label){
            //let result = label.replace(/<[^>]*>?/gm, '');
            let result = label.replace(/\s*style=(["'])(.*?)\1/gmi, '')
            .replace(/<p[^>]*>/gmi, '');;
            
            return result;
          },
          isEditable() {
                if (this.isForced) {
                    return true;
                }
                return !!this.value && this.notEditable == 1 && this.level_access !== 1;
            },
        }
    }
</script>

<style scoped>
    .red {
        color: #D95A4B !important;
    }
    
    .custom-radio-other {
        align-items: center;
        display: grid;
        gap: 4px;
        grid-template-columns: auto 1fr;
        justify-self: left;
    }
</style>
